/*! form-guard 1.1 -- Organizen
 *  Barriere anti-bot universelle, cote navigateur. Zero dependance, zero cout,
 *  invisible pour l'humain, ~2 ko.
 *
 *  Ce qu'il fait, sur CHAQUE formulaire de la page :
 *   1. ajoute un champ piege (par defaut "website" ; "fg_hp" si le site utilise
 *      deja "website" comme vrai champ) -- un humain ne le voit pas, un bot le remplit ;
 *   2. ajoute deux champs caches "fg_ts" (heure de chargement) et "fg_k" (empreinte
 *      calculee en JavaScript) : un bot qui poste sans executer le JS n'a pas la paire.
 *  Le serveur verifie les trois. Aucun blocage cote navigateur : c'est le serveur
 *  qui decide, sinon un humain avec remplissage automatique serait rejete sans le savoir.
 *
 *  Pose :  <script src="/assets/js/form-guard.js" defer></script>
 *  Reglage optionnel AVANT le script :
 *     <script>window.FORM_GUARD = { champ: "fg_hp", ignorer: ".no-guard" };</script>
 *
 *  Le verificateur serveur correspondant :
 *     Node/Worker : guard_server.js  |  Python/FastAPI/n8n : guard_server.py
 *  Les trois fichiers doivent garder la MEME fonction d'empreinte (fgKey).
 *
 *  v1.1 (revue securite 2026-08-02) : piege lu DANS le formulaire concerne et non
 *  dans tout le document (sinon un vrai champ "website" rempli par le visiteur
 *  classait 100 % des prospects en bots), jeton re-horodate a l'envoi, hote
 *  externe compare strictement, panier et recherche exclus aussi du hook fetch.
 */
(function () {
  "use strict";

  var CFG = window.FORM_GUARD || {};
  var CHAMP_PIEGE = CFG.champ || "website";
  var IGNORER = CFG.ignorer || "";
  var CHARGE_A = Date.now();
  var MARQUE = "data-form-guard";

  // Empreinte : doit etre identique dans guard_server.js et guard_server.py.
  function fgKey(ts) {
    var s = String(ts % 1000000007);
    var h = 0;
    for (var i = 0; i < s.length; i++) {
      h = (h * 31 + s.charCodeAt(i)) % 2147483647;
    }
    return h.toString(36);
  }

  // Formulaires qu'on ne touche pas : recherche, panier, opt-out explicite.
  var RE_HORS_SUJET = /\/search|\/recherche|\/cart|\/panier|\/cart\/add/i;

  function horsSujet(chemin) {
    return RE_HORS_SUJET.test(chemin || "");
  }

  function cacher(el) {
    el.setAttribute("tabindex", "-1");
    el.setAttribute("autocomplete", "off");
    el.setAttribute("aria-hidden", "true");
    el.style.cssText =
      "position:absolute!important;left:-9999px!important;top:auto!important;" +
      "width:1px!important;height:1px!important;overflow:hidden!important;" +
      "opacity:0!important;pointer-events:none!important";
  }

  function champCache(form, nom, valeur) {
    var ex = form.querySelector('input[type="hidden"][name="' + nom + '"]');
    if (ex) { ex.value = valeur; return ex; }
    var i = document.createElement("input");
    i.type = "hidden";
    i.name = nom;
    i.value = valeur;
    form.appendChild(i);
    return i;
  }

  function equiper(form) {
    if (form.getAttribute(MARQUE) === "1") return;
    if (IGNORER && form.matches && form.matches(IGNORER)) return;
    var act = (form.getAttribute("action") || "").toLowerCase();
    if (form.getAttribute("role") === "search" || horsSujet(act) || /[?&]s=/.test(act)) return;

    form.setAttribute(MARQUE, "1");

    // Le piege. S'il existe DEJA un champ portant ce nom dans ce formulaire,
    // c'est un vrai champ metier : on bascule sur "fg_hp" plutot que de renoncer
    // (renoncer laissait le formulaire sans piege, en silence).
    var nomPiege = CHAMP_PIEGE;
    if (form.querySelector('[name="' + nomPiege + '"]')) {
      nomPiege = "fg_hp";
      if (form.querySelector('[name="fg_hp"]')) nomPiege = null;  // deja pose
    }
    if (nomPiege) {
      var wrap = document.createElement("div");
      cacher(wrap);
      var lab = document.createElement("label");
      lab.textContent = "Ne pas remplir";
      lab.setAttribute("for", "fg-piege-" + nomPiege);
      var inp = document.createElement("input");
      inp.type = "text";
      inp.name = nomPiege;
      inp.id = "fg-piege-" + nomPiege;
      inp.value = "";
      inp.setAttribute("autocomplete", "off");
      inp.setAttribute("tabindex", "-1");
      wrap.appendChild(lab);
      wrap.appendChild(inp);
      form.appendChild(wrap);
    }
    form.setAttribute("data-fg-piege", nomPiege || "fg_hp");

    horodater(form);
    // Re-horodatage a l'envoi : un onglet laisse ouvert toute la journee
    // gardait sinon un jeton de six heures d'age, donc perime, et le visiteur
    // etait rejete sans jamais le savoir.
    form.addEventListener("submit", function () { horodater(form); }, true);
  }

  // Le serveur exige un ecart minimal de 2 s entre chargement et envoi. On
  // reporte donc l'heure de chargement, sauf si l'envoi est trop rapide : dans
  // ce cas on laisse le vrai horodatage, c'est justement le signal a transmettre.
  function horodater(form) {
    var maintenant = Date.now();
    var ts = (maintenant - CHARGE_A > 5000) ? (maintenant - 5000) : CHARGE_A;
    champCache(form, "fg_ts", String(ts));
    champCache(form, "fg_k", fgKey(ts));
  }

  function equiperTout() {
    var forms = document.querySelectorAll("form:not([" + MARQUE + "])");
    for (var i = 0; i < forms.length; i++) equiper(forms[i]);
  }

  // Valeur du piege du formulaire le plus proche du champ courant. Portee
  // volontairement locale : un querySelector sur tout le document ramassait le
  // vrai champ "website" d'un autre formulaire de la page.
  function valeurPiege(form) {
    if (!form) {
      var actif = document.activeElement;
      form = (actif && actif.form) || document.querySelector("form[" + MARQUE + "]");
    }
    if (!form) return "";
    var nom = form.getAttribute("data-fg-piege") || "fg_hp";
    var el = form.querySelector('[name="' + nom + '"]');
    return el ? String(el.value || "") : "";
  }

  function jetonCourant() {
    var maintenant = Date.now();
    return (maintenant - CHARGE_A > 5000) ? (maintenant - 5000) : CHARGE_A;
  }

  // --- Envois en fetch() ---------------------------------------------------
  // La majorite des formulaires modernes ne postent pas le <form> : ils appellent
  // fetch() avec un corps JSON construit a la main. Plutot que de modifier chaque
  // appel de chaque page, on greffe le jeton au passage.
  // On ne touche QUE : meme origine (ou hote explicitement autorise), methode
  // POST, corps JSON objet, chemin qui n'est ni un panier ni une recherche.
  if (CFG.fetch !== false && window.fetch) {
    var fetchOrigine = window.fetch;
    var hotesAmis = CFG.hotes || [];
    window.fetch = function (entree, init) {
      try {
        init = init || {};
        var url = "";
        if (typeof entree === "string") {
          url = entree;
        } else if (entree instanceof URL) {
          url = entree.href;
        } else if (entree && typeof entree.url === "string") {
          url = entree.url;                      // Request
        }
        var methode = String(init.method || (entree && entree.method) || "GET").toUpperCase();
        if (url && methode === "POST" && typeof init.body === "string" &&
            init.body.charAt(0) === "{") {
          var abs = new URL(url, location.href);
          // Comparaison stricte de l'hote : "endsWith" laissait passer
          // evil-monsite.fr pour monsite.fr.
          var interne = abs.origin === location.origin || hotesAmis.some(function (h) {
            var n = String(h).replace(/^https?:\/\//, "").replace(/\/$/, "");
            return abs.host === n || abs.host.slice(-(n.length + 1)) === "." + n;
          });
          if (interne && !horsSujet(abs.pathname)) {
            var corps = JSON.parse(init.body);
            if (corps && typeof corps === "object" && !Array.isArray(corps)) {
              var ts = jetonCourant();
              if (corps.fg_ts === undefined) corps.fg_ts = ts;
              if (corps.fg_k === undefined) corps.fg_k = fgKey(ts);
              if (corps.fg_hp === undefined) corps.fg_hp = valeurPiege(null);
              init = Object.assign({}, init, { body: JSON.stringify(corps) });
            }
          }
        }
      } catch (e) { /* jamais casser un envoi a cause de la barriere */ }
      // call(window) et pas call(this) : en mode strict, un appel deshabille
      // (const {fetch} = window) donne this === undefined -> Illegal invocation.
      return fetchOrigine.call(window, entree, init);
    };
  }

  // Expose l'empreinte : utile aux formulaires qui postent sans <form>.
  window.formGuard = {
    ts: jetonCourant,
    cle: function () { return fgKey(jetonCourant()); },
    charge: function (obj, form) {
      obj = obj || {};
      var ts = jetonCourant();
      obj.fg_hp = valeurPiege(form || null);
      obj.fg_ts = ts;
      obj.fg_k = fgKey(ts);
      return obj;
    },
    equiper: equiper
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", equiperTout);
  } else {
    equiperTout();
  }

  // Les formulaires ajoutes apres coup (modale, application monopage) sont
  // equipes aussi. Freine volontairement : sans cela, chaque animation GSAP
  // relancait un balayage complet du document (regle anti-boucle CLAUDE.md).
  if (window.MutationObserver) {
    var enAttente = false;
    var passages = 0;
    var PASSAGES_MAX = 300;
    var obs = new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      setTimeout(function () {
        enAttente = false;
        passages += 1;
        if (passages > PASSAGES_MAX) { obs.disconnect(); return; }
        equiperTout();
      }, 400);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
